/**
 * System Questionnaires - Psychology / emotional therapy clinics
 *
 * Read-only questionnaires for psychology, psychotherapy, emotional therapy
 * and clinical social work clinics (incl. CBT-oriented practices).
 */

const PSYCH_CLINIC_TYPES = [
  "psychology",
  "emotional_therapy",
  "clinical_social_work",
];

export const psychologistQuestionnaires = [
  {
    id: "sys_quest_weekly_checkin",
    name: "שאלון מעקב שבועי (CBT)",
    fields: [
      {
        id: "sq_wc_01",
        type: "radio",
        label: "איך היה מצב הרוח שלך השבוע, בממוצע? (1 = נמוך מאוד, 10 = מצוין)",
        required: true,
        options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      },
      {
        id: "sq_wc_02",
        type: "radio",
        label: "רמת החרדה / המתח השבוע",
        required: true,
        options: ["נמוכה", "בינונית", "גבוהה", "גבוהה מאוד"],
      },
      {
        id: "sq_wc_03",
        type: "radio",
        label: "איכות השינה השבוע",
        required: false,
        options: ["טובה", "סבירה", "ירודה"],
      },
      {
        id: "sq_wc_04",
        type: "checkbox",
        label: "ביצעתי את משימות הבית שסיכמנו",
        required: false,
      },
      {
        id: "sq_wc_05",
        type: "long_text",
        label: "מצב או מחשבה שהיו קשים במיוחד השבוע",
        required: false,
      },
      {
        id: "sq_wc_06",
        type: "long_text",
        label: "משהו שהצליח או שהרגשת בו התקדמות",
        required: false,
      },
    ],
    isSystem: true,
    clinicTypes: PSYCH_CLINIC_TYPES,
  },
];
